import { ProjectQuoteUserProperties } from 'src/model/api/project.model';

export const overrideColumnVisibilities = (table: any, quoteUserProperties: ProjectQuoteUserProperties) => {
  const newCols = Object.assign([], table.columns);

  newCols.filter((col: any) => col.data.indexOf("price_") === 0)
    .forEach((col: any) => (col.visible = quoteUserProperties.include_prices === 1));

  const col = newCols.find((col: any) => col.data === 'discount');
  if (col) {
    col.visible = false;
  }
  return newCols;
};

export const overrideRowVisibilities = (rows: any, quoteUserProperties: ProjectQuoteUserProperties) => {
  if (quoteUserProperties.include_back_boxes === 0) {
    return rows.filter((row: any) => !row.is_back_box);
  }
  return rows;
};
